import './styles/graphic.scss';

export default function (props, container, isMobile) {
  const {
    initialWidth,
    initialHeight,
  } = props;

  // const svg = container.append('svg')
  //   .attr('width', initialWidth)
  //   .attr('height', initialHeight);

  // svg.append('text')
  //   .attr('x', initialWidth / 2)
  //   .attr('y', initialHeight / 2)
  //   .attr('text-anchor', 'middle')
  //   .attr('font-size', 20)
  //   .text('Draw here');
}
